module.exports = __webpack_public_path__ + "media/images/icon/station-a579f0b7be544248ff49533c81e7f30a.svg";